/** 떠 있는 상자(목록 · 달력 · 메뉴)를 기준 요소의 아래 또는 위에 둘 자리 */
export interface FloatingPlacement {
  top: number;
  left: number;
  placement: 'bottom' | 'top';
  /** 고른 쪽에 남은 높이 — 상자가 이보다 크면 줄여 안에서 스크롤하게 한다 */
  maxHeight: number;
}

interface Box {
  width: number;
  height: number;
}

export interface PlaceFloatingInput {
  /** 기준 요소의 화면 좌표(getBoundingClientRect) */
  anchor: { top: number; bottom: number; left: number };
  /** 상자의 본래 크기(높이 제한 전) */
  floating: Box;
  /** 화면 크기 */
  viewport: Box;
  /** 기준 요소와 상자 사이 */
  gap: number;
  /** 화면 가장자리에서 띄울 거리 */
  margin?: number;
}

/** 화면 가장자리 여백 기본값 */
export const FLOATING_VIEWPORT_MARGIN_PX = 8;

/**
 * 기본은 아래. 아래 공간이 상자보다 작고 위가 더 넓으면 위로 뒤집는다.
 * 양쪽 다 모자라면 넓은 쪽에 두고 maxHeight 로 줄인다. 가로는 화면 안으로 당긴다(왼쪽 우선).
 */
export function placeFloating({
  anchor,
  floating,
  viewport,
  gap,
  margin = FLOATING_VIEWPORT_MARGIN_PX,
}: PlaceFloatingInput): FloatingPlacement {
  const below = viewport.height - anchor.bottom - gap - margin;
  const above = anchor.top - gap - margin;
  const placement = floating.height <= below || below >= above ? 'bottom' : 'top';
  const maxHeight = Math.max(0, placement === 'bottom' ? below : above);
  const height = Math.min(floating.height, maxHeight);
  const top = placement === 'bottom' ? anchor.bottom + gap : anchor.top - gap - height;
  const rightmost = viewport.width - margin - floating.width;
  const left = Math.max(margin, Math.min(anchor.left, rightmost));
  return { top, left, placement, maxHeight };
}
